/* Focus the inline finder without opening or moving to another interface. */
(() => {
 const input=document.getElementById('head-finder-q');
 document.addEventListener('keydown',event=>{
  if(event.key!=='/'||event.ctrlKey||event.metaKey||event.altKey||event.target.closest('input,textarea,select,[contenteditable=true]')||document.body.classList.contains('p26-menu-open'))return;
  if(input?.getClientRects().length){event.preventDefault();input.focus();}
 });
})();

